export const RESTORE_SESSION_REQUEST = "RESTORE_SESSION_REQUEST";
export const RESTORE_SESSION_SUCCESS = "RESTORE_SESSION_SUCCESS";
export const RESTORE_SESSION_FAIL = "RESTORE_SESSION_FAIL";
export const CLEAR_ERROR_REQUEST = "CLEAR_ERROR_REQUEST";
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const GET_PB_RESTRICTION = "GET_PB_RESTRICTION";
export const GET_SESSION_INFO = "GET_SESSION_INFO";
export const GET_SESSION_SUCCESS = "GET_SESSION_SUCCESS";
export const GET_SESSION_FAIL = "GET_SESSION_FAIL";
export const GET_KILL_SWITCH_MESSAGE = "GET_KILL_SWITCH_MESSAGE";
export const GET_KILL_SWITCH_MESSAGE_SUCCESS = "GET_KILL_SWITCH_MESSAGE_SUCCESS";
export const GET_KILL_SWITCH_MESSAGE_FAIL = "GET_KILL_SWITCH_MESSAGE_FAIL";
export const ENCRYPT_TOKEN_REQUEST = "ENCRYPT_TOKEN_REQUEST";
export const ENCRYPT_TOKEN_SUCCESS = "ENCRYPT_TOKEN_SUCCESS";
export const ENCRYPT_TOKEN_FAIL = "ENCRYPT_TOKEN_FAIL";

